var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEliminatePaperRightMobile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 191,
    viewBox: "0 0 157 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.2488 1.5127L87.2481 -6.56664L116.247 -14.648L145.247 -22.7274L154.883 -25.4123",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.873 3.95093L88.1855 -2.90946L117.496 -9.7678L146.808 -16.6302L156.146 -18.815",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3923 6.41504L88.9666 0.785839L118.539 -4.8454L148.109 -10.4725L156.244 -12.0223",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8098 8.89795L89.5928 4.50812L119.372 0.120335L149.153 -4.26746L154.904 -5.1148",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1228 11.3933L90.0591 8.25305L119.996 5.11483L149.932 1.97254L151.612 1.79693",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3298 13.9023L90.3726 12.0157L120.413 10.1291L145.489 8.55491",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4341 16.4155L90.5261 15.7867L120.62 15.1578L136.468 14.827",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4341 18.9311L90.5261 19.56L120.62 20.1889L127.151 20.3257",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3298 21.4466L90.3726 23.3332L120.311 25.2117",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1228 23.9543L90.0591 27.0945L115.63 29.7754",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8098 26.4509L89.5928 30.8387L112.358 34.1934",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3923 28.9317L88.9666 34.5629L110.234 38.6118",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.873 31.3967L88.1855 38.2571L109.306 43.1982",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2488 33.8346L87.2481 41.9139L110.768 48.468",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5225 36.2436L86.1577 45.5316L114.795 54.8156L118.148 55.9019",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6943 38.6205L84.9162 49.0969L113.138 59.5713L128.206 65.1658",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7649 40.9623L83.5223 52.6086L111.28 64.2529L134.917 74.1658",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.738 43.2615L81.9841 56.0553L109.228 68.8512L136.472 81.645L139.633 83.1294",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6145 45.5174L80.2998 59.4362L106.983 73.3591L133.667 87.2821L142.988 92.1436",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3992 47.7202L78.4769 62.7457L104.551 77.7691L130.626 92.7925L144.745 100.927",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0923 49.8747L76.5152 65.9742L101.936 82.0737L127.357 98.1752L144.684 109.148",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6948 51.9693L74.4202 69.1162L99.1435 86.2652L123.865 103.412L142.716 116.486",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2109 54.0051L72.1937 72.1688L96.1743 90.3366L120.157 108.5L139.027 122.797",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6438 55.9771L69.8409 75.1269L93.04 94.2788L116.237 113.429L134.065 128.148",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9951 57.8825L67.3695 77.9859L89.742 98.0893L112.115 118.191L128.175 132.624",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2725 59.7163L64.7796 80.7364L86.2907 101.757L107.798 122.777L121.608 136.273",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4697 61.4778L62.0766 83.3779L82.6875 105.28L103.294 127.178L114.535 139.125",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M39.594 63.1605L59.2658 85.9039L78.9377 108.649L98.6074 131.391L107.071 141.177",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6523 64.7656L56.3544 88.3135L75.0545 111.859L93.7545 135.403L99.3032 142.39",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6455 66.2884L53.3409 90.5979L71.0384 114.903L88.7339 139.211L91.2545 142.674",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5747 67.726L50.2348 92.7542L66.8972 117.78L82.8985 141.816",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4446 69.0778L47.0429 94.7798L62.6393 120.48L74.072 139.315",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2615 70.3351L43.7652 96.668L58.271 122.999L64.5398 134.378",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0276 71.5031L40.4163 98.42L53.8031 125.333L54.6173 126.97",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7444 72.5748L36.9915 100.027L46.2434 120.769",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M22.418 73.5509L33.5029 101.491L39.9374 117.708",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0552 74.4266L29.9576 102.803L34.743 116.516",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6548 75.2026L26.3563 103.967L30.1413 116.473",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2266 75.8787L22.7127 104.98L25.9186 117.439",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M12.769 76.4486L19.0276 105.84L21.8673 119.165",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2915 76.916L15.3122 106.54L17.8534 121.537",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79541 77.2813L11.5681 107.085L13.7757 124.52",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28687 77.5407L7.80754 107.475L9.57729 128.51",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77271 77.6963L4.03304 107.708L5.17462 134.917",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0.250244 77.7471V142.231",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEliminatePaperRightMobile);
export default __webpack_public_path__ + "static/media/eliminate-paper-right-mobile.41b8eafe13bad8856e98c9705773017a.svg";
export { ForwardRef as ReactComponent };